<!--
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-10 17:18:44
 * @Reference:
-->
<template>
  <div class="homepage">
    <ak-model-count-group :options="orderoptions"></ak-model-count-group>
    <!-- <ak-model-chart class="m-t-30" title="订单统计图" :options="orderOptions" /> -->
    <ak-model-chart class="m-t-30" title="用户统计图" :options="peopleOptions"></ak-model-chart>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data () {
    return {
      radio: '',
      checked: false,
      chart: null,
      time: null,
      createTime: [
        moment().startOf('month'),
        moment().endOf('month')
      ],
      orderoptions: [
        {
          model: 'user1',
          icon: 'user',
          sum: 'statistics',
          format: (val) => `${(val || 0)} 人`,
          note: '小程序用户数量'
        },
        {
          model: 'problemCheck',
          icon: 'question-circle',
          note: '问老张数量',
          format: (val) => `${(val || 0)}个`
        },
        {
          model: 'redBlack',
          icon: 'ordered-list',
          format: (val) => `${(val || 0)}个`,
          note: '红黑榜数量'
        },
        {
          model: 'secondHand',
          icon: 'transaction',
          note: '二手信息数量',
          format: (val) => `${(val || 0)}个`
        }
      ],
      peopleOptions: [
        {
          model: 'user1',
          chartType: 'line',
          name: '小程序用户',
          where: {
            statistics: 1
          }
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
.homepage{
  width: 100%;
  height: 100%;
}
.nanhe-chart{
  .chart-header{
    display: flex;
    justify-content: space-between;
    .title{
    }
  }
}
</style>
